<template>
  <section>
    <div class="form-content">

      <div class="clear">
        <el-col :span="12">
          <el-form-item label="申请部门">
            <el-input size="small" :disabled="true" v-model="userData.childDept"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="申请人">
            <el-input size="small" :disabled="true" v-model="userData.name"></el-input>
          </el-form-item>
        </el-col>
      </div>

      <el-form-item label="关联工程(选填)">
        <el-select @change="forceUpdate" size="small" class="project-list-select" v-model="form.projectIds"
          filterable multiple placeholder="请选择">
          <el-option v-for="item in projectList" :key="item.id" :label="item.number+'-'+item.name" :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>

      <div class="clear">
        <el-col :span="12">
          <el-form-item label="采购项目">
            <el-input size="small" v-model="form.name"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item v-if="type==0" label="招标方式">
            <el-select size="small" v-model="form.zbfs" placeholder="请选择招标方式">
              <el-option v-for="item in zbfsArr" :key="item" :label="item" :value="item">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </div>
      <div class="clear">
        <el-col :span="12">
          <el-form-item label="供货单位">
            <el-autocomplete size="small" style="width:300px;" v-model="form.ghdw"
              :fetch-suggestions="querySearchAsyncByghdw" placeholder="请输入"></el-autocomplete>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="供货期限">
            <el-input size="small" v-model="form.ghqx"></el-input>
          </el-form-item>
        </el-col>
      </div>
      <div class="clear">
        <!-- <el-col :span=> -->
        <el-form-item label="供货合同编号">
          <el-checkbox style="float:left;margin-right:15px;" v-model="hasHtbh">关联合同编号</el-checkbox>
          <el-autocomplete v-if="hasHtbh" size="small" style="width:300px;" v-model="form.htbh"
            :fetch-suggestions="querySearchAsyncByhtbh" placeholder="请输入合同编号"></el-autocomplete>
        </el-form-item>
        <!-- </el-col> -->
      </div>
      <div class="clear">
        <el-col :span="8">
          <el-form-item label="合同总价">
            <el-input type="number" size="small" v-model="form.htzj"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="本次采购批次">
            <el-input type="number" size="small" v-model="form.bccgpc"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="本次采购价">
            <el-input type="number" size="small" v-model="form.bccgj"></el-input>
          </el-form-item>
        </el-col>
      </div>
      <div class="clear">
        <el-col :span="8">
          <el-form-item label="已经采购价">
            <el-input type="number" size="small" v-model="form.yjcgh"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="至本次采购总价">
            <el-input type="number" size="small" v-model="form.zbccgzj"></el-input>
          </el-form-item>
        </el-col>
      </div>


      <el-form-ite <el-form-item label="申请理由">
        <el-input type="textarea" placeholder="申请采购的原因简要说明" :autosize="{ minRows: 3, maxRows: 6}" size="small"
          v-model="form.reason"></el-input>
        </el-form-item>
    </div>
  </section>

</template>
<script>
  export default {
    props: ['formByFather', 'userData', 'type'],
    data() {
      return {
        form: {},

        // 子公司部们depid
        depIdSub: '',
        // 选择项目列表
        projectList: [],

        hasHtbh: false,
        zbfsArr: ["单一来源", "竞争性谈判", "邀请招标", "公开招标", "询比价招标"],

        addStatus: false,
        userDeptId: "",
      }
    },
    created() {
      ajax.get('/user/dept', '', (res) => {
        this.userDeptId = res.vo.array[0].id
        this.depIdSub = this.form.depId = this.userDeptId
      })
    },
    mounted() {
      this.form = this.formByFather
      this.form.depId = this.depIdSub
      if (this.form.htbh) {
        this.hasHtbh = true
      }

      // 获取项目列表
      this.getProjectList(() => {

      })
    },
    methods: {
      // 获取合同信息
      getHtInfo() {
        ajax.get('/purchase/apply/ht/info', {
          depId: this.form.depId,
          ghdw: this.form.ghdw,
          htbh: this.form.htbh
        }, res => {
          this.form.htzj = res.vo.htzj
          this.form.bccgpc = res.vo.bccgpc
          // this.form.bccgj = res.vo.bccgj
          this.form.yjcgh = res.vo.yjcgh
          // this.form.zbccgzj = res.vo.zbccgzj
        })
      },

      // 搜索合同编号
      querySearchAsyncByhtbh(queryString, cb) {
        ajax.get('/purchase/apply/htbh/list', {
          depId: this.form.depId,
          ghdw: this.form.ghdw,
          htbh: this.form.htbh
        }, res => {
          let results = []
          if (res.vo.datas) {
            for (let i = 0; i < res.vo.datas.length; i++) {
              results.push({
                "value": res.vo.datas[i]
              })
            }
          }
          cb(results)
        })
      },
      // 搜索供货单位
      querySearchAsyncByghdw(queryString, cb) {
        ajax.get('/purchase/apply/ghdw/list', {
          depId: this.form.depId,
          ghdw: this.form.ghdw
        }, res => {
          let results = []
          if (res.vo.datas) {
            for (let i = 0; i < res.vo.datas.length; i++) {
              results.push({
                "value": res.vo.datas[i]
              })
            }
          }
          cb(results)
        })
      },


      // select刷新view
      forceUpdate(item) {
        this.$forceUpdate()
      },
      // 获取项目列表
      getProjectList(cb) {
        ajax.get('/contract/project/choose/list', {
          depId: ''
        }, (res) => {
          this.projectList = res.vo.array
          cb && cb()
        })
      },
      // 通过项目ID获取项目Name
      getProjectNameById() {
        let name = []
        for (let i = 0; i < this.form.projectIds.length; i++) {
          let _id = this.form.projectIds[i]
          for (let j = 0; j < this.projectList.length; j++) {
            if (this.projectList[j].id == _id) {
              name.push(this.projectList[j].name)
              break
            }
          }
        }
        return name.join(",")
      },

      // 编辑采购项目
      MaterialChange(row, index) {
        this.addType = 1
        this.editIndex = index
        this.mform = row
        this.addStatus = true
      },
      // 从列表里删除当前采购项目
      MaterialDelete(index) {
        this.form.purchaseItems.splice(index, 1)
      },
      // 显示添加采购项目弹窗
      AddMaterial() {
        // 初始化
        this.mform = {
          name: '',
          spec: '',
          price: '',
          amount: 1,
          fee: '',
          remark: '',
        }
        this.addType = 0
        this.addStatus = true
      },
      // 添加采购项目到列表
      AddBtnClick() {
        if (!this.mform.name || !this.mform.price || !this.mform.amount) {
          this.$message.error("请认真填写采购信息，带*为必填项")
          return
        }
        if (this.addType == 0) {
          this.form.purchaseItems.push(this.mform)
        } else {
          this.form.purchaseItems.splice(this.editIndex, 1, this.mform)
        }
        this.addStatus = false

        this.fixedTotalPrice()
      },
      // 返回form
      getFromData() {
        this.form.projectNames = this.getProjectNameById()
        return this.form
      },
      // 计算某项目总价
      fixedFee() {
        if (this.mform.price && this.mform.amount) {
          this.mform.fee = (this.mform.price * this.mform.amount).toFixed(2)
        }
      },
      // 计算真实总价
      fixedTotalPrice() {
        let _total = 0
        for (var i = 0; i < this.form.purchaseItems.length; i++) {
          _total += parseFloat(this.form.purchaseItems[i].fee)
        }
        this.form.priceNum = _total.toFixed(2)
        this.form.price = util.convertCurrency(this.form.priceNum)
      },
    },
    watch: {
      "mform.price"() {
        this.fixedFee()
      },
      "mform.amount"() {
        this.fixedFee()
      },
      "form.type"() {
        // type:0 部门  type:1 公司
        if (this.form.type == 1) {
          this.form.depId = this.userData.secDepIds.split(",")[0] / 1
        } else {
          this.form.depId = this.userDeptId
        }
      },
      formByFather() {
        this.form = this.formByFather
        this.form.depId = this.depIdSub
        if (this.form.htbh) {
          this.hasHtbh = true
        }
      },
      // "form.depId"() {
      //   if (this.form.ghdw && this.form.htbh) {
      //     this.getHtInfo()
      //   }
      // },
      "form.ghdw"() {
        if (this.form.ghdw && this.form.htbh && !this.form.applyId) {
          this.getHtInfo()
        }
      },
      "form.htbh"() {
        if (this.form.ghdw && this.form.htbh && !this.form.applyId) {
          this.getHtInfo()
        }
      },

      "form.bccgj"() {
        if (this.form.bccgj && this.form.yjcgh) {
          this.form.zbccgzj = (this.form.bccgj / 1 + this.form.yjcgh / 1).toFixed(2)
        }
      },
      "form.yjcgh"() {
        if (this.form.bccgj && this.form.yjcgh) {
          this.form.zbccgzj = (this.form.bccgj / 1 + this.form.yjcgh / 1).toFixed(2)
        }
      },
    }
  }
</script>


// WEBPACK FOOTER //
// src/page/form/purchase/applySubsidiary.vue